import { apiService } from './api';
import Constants from 'expo-constants';

export interface PaymentIntentionParams {
  amount: number; // Amount in specified currency (e.g., 100)
  currency?: string; // Currency code (USD, EGP, etc.)
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  description?: string;
  merchantOrderId?: string;
}

export interface PaymentIntentionResponse {
  payment_key: string;
  order_id: number;
  iframe_url: string;
}

class PaymobService {
  private publicKey: string;
  private iframeId: string;

  constructor() {
    // Get from app.json extra config
    this.publicKey = Constants.expoConfig?.extra?.paymobPublicKey || '';
    this.iframeId = Constants.expoConfig?.extra?.paymobIframeId || '';
  }

  /**
   * Create payment intention via backend
   */
  async createPaymentIntention(
    params: PaymentIntentionParams
  ): Promise<PaymentIntentionResponse> {
    try {
      console.log('[PaymobService] Creating payment intention:', {
        amount: params.amount,
        email: params.email
      });

      const response = await apiService.authenticatedRequest<PaymentIntentionResponse>(
        '/api/payments/paymob/create-intention',
        {
          method: 'POST',
          body: JSON.stringify({
            amount: params.amount,
            currency: params.currency || 'USD', // Use provided currency or default to USD
            billing_data: {
              first_name: params.firstName,
              last_name: params.lastName,
              email: params.email,
              phone_number: params.phoneNumber,
            },
            merchant_order_id: params.merchantOrderId || `ORDER_${Date.now()}`,
            description: params.description
          })
        }
      );

      if (!response.success) {
        throw new Error(response.message || 'Failed to create payment intention');
      }

      console.log('[PaymobService] Payment intention created:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('[PaymobService] Create intention error:', error);
      throw error;
    }
  }

  /**
   * Get payment iframe URL
   */
  getIframeUrl(paymentKey: string): string {
    return `https://accept.paymob.com/api/acceptance/iframes/${this.iframeId}?payment_token=${paymentKey}`;
  }
}

export const paymobService = new PaymobService();

